<template>
  <div>
    <el-upload ref="upload" action="" :auto-upload="false" :show-file-list="false" :accept="acceptStr" :on-change="onFileChange">
      <el-button slot="trigger" icon="el-icon-upload" type="primary">导入文件</el-button>

      <!-- <a style="margin-left: 5px;" :href="templateUrl"> -->
       <a style="margin-left: 5px;">
        <el-button @click="downModule">模板下载</el-button>
      </a>
    </el-upload>
    <el-dialog append-to-body modal-append-to-body :visible="dialogVisible" title="添加空投" width="1200px" @close="closeDialog">
      <div class="section">
        <el-button type="danger" v-if="hasError" @click="removeAllError" size="small">删除所有异常数据</el-button>
      </div>
      <div class="section">
        <el-table :data="pagedDropList" border style="width: 100%">
          <el-table-column prop="userId" label="用户（ID/emall/userid/邀请码）">
            <template slot-scope="scope">
              <div v-if="scope.row.userId">
                {{scope.row.userId}}
              </div>
              <div v-if="scope.row.remark">
                <el-tag v-if="mark && mark.trim()"  style="margin: 0 3px 3px 0" v-for="mark in (scope.row.remark || '').split(' ')" :key="mark" type="danger">{{mark}}</el-tag>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="coinType" label="币种"/>
          <el-table-column prop="coinAmount" label="空投数量"></el-table-column>
          <el-table-column prop="redeemCode" label="空投卡券"></el-table-column>
          <!-- <el-table-column prop="tel" label="电话"/>
          <el-table-column prop="email" label="邮箱"/>
          <el-table-column prop="inviteCode" label="邀请码"/> -->
          <!-- <el-table-column prop="coinAmount" label="可用数量"/>
          <el-table-column prop="coinFroze" label="冻结数量"/>
          <el-table-column prop="redeemCode" label="兑换码"/> -->
          <el-table-column  label="操作">
            <template slot-scope="scope">
              <el-button :type="!scope.row.userId? 'danger': 'default'" @click="remove(scope.$index)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <pagination :size="pagination.size" :page="pagination.page" :total="totalCount" @pageChanged="handleCurrentChange"/>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button :type=" showError ? 'info' : 'danger'" @click="showError = !showError">{{showError ? '隐藏错误数据' : '展示错误数据'}}</el-button>
        <el-button type="primary" @click="submit">确认导入</el-button>
        <el-table :data="errorList" v-show="showError">
          <el-table-column prop="userId" label="用户（ID/emall/userid/邀请码）" align="center"></el-table-column>
          <el-table-column prop="coinType" label="币种"/>
          <el-table-column prop="coinAmount" label="空投数量"></el-table-column>
          <el-table-column prop="redeemCode" label="空投卡券"></el-table-column>
          <!-- <el-table-column prop="userId" label="userId" align="center"></el-table-column>
          <el-table-column prop="tel" label="tel" align="center"></el-table-column>
          <el-table-column prop="email" label="email" align="center"></el-table-column>
          <el-table-column prop="inviteCode" label="inviteCode" align="center"></el-table-column> -->
        </el-table>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import XLSX from 'xlsx';
import Pagination from 'components/pagination';
import {TEMPLATE_URL} from '../../constants.js';
import api from '../../api.js'
export default {
  name: 'CreateAirDrop',
  props: ['value'],
  data() {
    return {
      accept: ['xlsx', 'xls', 'csv'],
      dialogVisible: false,
      pagination: {
        page: 1,
        size: 100
      },
      totalCount: 0,
      airdropList: [],
      templateUrl: TEMPLATE_URL,
      showError: true,
      errorList:[],
    };
  },
  computed: {
    acceptStr() {
      return this.accept.map(item => `.${item}`).join(', ');
    },
    pagedDropList() {
      const { page, size } = this.pagination;
      const trimedId = this.idFilterVal && this.idFilterVal.trim();
      return this.airdropList.slice(
        (this.pagination.page - 1) * this.pagination.size,
        this.pagination.page * this.pagination.size
      );
    },
    hasError() {
      return this.airdropList.find(item => !item.userId);
    }
  },
  components: {
    Pagination
  },
  methods: {
    ...mapActions('airdrop', ['checkAirDrop']),
    downModule(){
      api.exportExcelMoulds().then(res=>{
          let blob = new Blob([res],{type:'application/vnd.ms-excel'});
          let link = document.createElement('a');
          link.style.display = 'none';
          let objectUrl = URL.createObjectURL(blob);
          link.href = objectUrl;
          link.setAttribute('download','空投设置模板'+'.xlsx');
          link.click();
          URL.revokeObjectURL(objectUrl);
      })
    },
    submit() {
      this.$emit('input', this.airdropList.concat());
      this.$emit('change', this.airdropList.concat());
      this.$parent.$emit('el.form.change', this.airdropList.concat());
      this.closeDialog();
    },
    remove(index) {
      this.airdropList.splice(index, 1);
    },
    removeAllError() {
      this.airdropList = this.airdropList.filter(item => item.userId);
    },
    onFileChange(file) {
      if (!file) return;
      const { raw: originFile } = file;
      const { name, size } = originFile;
      const suffix = name.split('.').pop();
      if (!this.accept.includes(suffix)) {
        this.$message.error(`只能上传${this.acceptStr}格式的文件`);
        return;
      }
      console.log(originFile)
      this.readDataFromFile(originFile);
    },
    handleCurrentChange(pagination) {
      this.pagination = pagination;
    },
    uploadJson(json) {
      this.checkAirDrop({
            miningAirDrops: JSON.stringify(json)
          }).then((res) => {
            console.log(res.data);
              this.airdropList = res.data.rightList;
              this.totalCount = res.data.rightList.length;
              this.dialogVisible = true;
              this.errorList = res.data.errorList;
          });
    },
    readDataFromFile(file) {
      const that = this;
      const reader = new FileReader();
      reader.onload = function(e) {
        // pre-process data
        let binary = '';
        const bytes = new Uint8Array(e.target.result);
        const length = bytes.byteLength;
        for (let i = 0; i < length; i++) {
          binary += String.fromCharCode(bytes[i]);
        }

        /* read workbook */
        const wb = XLSX.read(binary, {
          type: 'binary'
        });
        /* grab first sheet */
        const wsname = wb.SheetNames[0];
        const ws = wb.Sheets[wsname];
    //币种 coinType 用户ID userId 空投数量 coinAmount   空投卡券  redeemCode
        /* generate HTML */
        const json = XLSX.utils.sheet_to_json(ws);
        let newary = []
        json.map(item=>{
            newary.push({coinType:item['币种'],userId:item['用户（ID/emall/userid/邀请码）'],coinAmount:item['空投数量'],redeemCode:item['空投卡卷']})
        })
        that.uploadJson(newary);
        // that.airdropList = json;
        // that.totalCount = json.length;
        // that.dialogVisible = true;
        /* update table */

        /* show export button */
      };

      reader.readAsArrayBuffer(file);
    },
    closeDialog() {
      this.dialogVisible = false;
      this.airdropList = []
      this.totalCount = 0;
      this.pagination = {
        page: 1,
        size: 100
      };
    }
  }
};
</script>


<style lang="less" scoped>
.section {
  margin-bottom: 10px;
}
</style>
